import { render } from "./AddOnListItem.vue?vue&type=template&id=7d0047ca&scoped=true"
import script from "./AddOnListItem.vue?vue&type=script&lang=js"
export * from "./AddOnListItem.vue?vue&type=script&lang=js"

import "./AddOnListItem.vue?vue&type=style&index=0&id=7d0047ca&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0047ca"]])

export default __exports__

/* vue-cli-plugin-import-components */
import PointsIcon from "@/components/PointsIcon.vue";
import ExpenseIcon from "@/components/ExpenseIcon.vue";
import Currency from "@/components/Currency.vue";
script.components = Object.assign({}, { PointsIcon, ExpenseIcon, Currency }, script.components);